import { Button, InputCurrency } from "@sellar-io/components";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useFulfillmentTypeCreate } from "../../../../hooks/api/v2/fulfillmentType/useFulfillmentTypeCreate";
import { useFulfillmentTypeUpdate } from "../../../../hooks/api/v2/fulfillmentType/useFulfillmentTypeUpdate";

export const FulfillmentTypeChargeCapUpdateDialog = ({
  active,
  onDismiss,
  deliveryChargeCap,
  fulfillmentTypeId,
}: {
  active: boolean;
  onDismiss: () => void;
  deliveryChargeCap?: number | null;
  fulfillmentTypeId?: number;
}) => {
  const form = useForm<{ deliveryChargeCap: number }>({
    shouldUseNativeValidation: true,
    defaultValues: {
      deliveryChargeCap: deliveryChargeCap ? deliveryChargeCap / 100 : 0,
    },
  });
  const formId = useId();

  const fulfillmentTypeCreateMutation = useFulfillmentTypeCreate();
  const fulfillmentTypeUpdateMutation = useFulfillmentTypeUpdate(
    fulfillmentTypeId ?? 0,
  );

  const onSubmit = (data: { deliveryChargeCap: number }) => {
    const deliveryChargeCap =
      parseFloat(data.deliveryChargeCap.toString()) * 100;
    if (!fulfillmentTypeId) {
      return fulfillmentTypeCreateMutation.mutate(
        {
          deliveryChargeCap,
          fulfillmentType: "courier",
        },
        {
          onSuccess: () => onDismiss(),
        },
      );
    }
    fulfillmentTypeUpdateMutation.mutate(
      {
        deliveryChargeCap,
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Update delivery charge cap"}
        description="Set a delivery charge cap to show your customers the most they can be charged for delivery for larger orders"
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        {fulfillmentTypeUpdateMutation.isError ||
        fulfillmentTypeCreateMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(
                fulfillmentTypeUpdateMutation.error ??
                  fulfillmentTypeCreateMutation.error,
              )?.response?.data.message ?? "Unknown error occurred."
            }
          />
        ) : null}
        <form
          id={formId}
          onSubmit={form.handleSubmit(onSubmit)}
          className={"flex flex-col gap-2"}
        >
          <InputLabel>Amount</InputLabel>
          <InputContainer>
            <InputCurrency
              showPrefix
              allowNegative
              {...form.register("deliveryChargeCap", {
                required: true,
                valueAsNumber: true,
              })}
            />
          </InputContainer>
        </form>
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          loading={
            fulfillmentTypeUpdateMutation.isPending ||
            fulfillmentTypeCreateMutation.isPending
          }
        >
          Update
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
